import { render, staticRenderFns } from "./VAT01.vue?vue&type=template&id=0876947e&scoped=true"
import script from "./VAT01.vue?vue&type=script&lang=js"
export * from "./VAT01.vue?vue&type=script&lang=js"
import style0 from "./VAT01.vue?vue&type=style&index=0&id=0876947e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876947e",
  null
  
)

export default component.exports